import { ContextualNavigationItem } from '../../../shared/services/contextual-sidebar.service';

/**
 * Les groupes du menu contextuel dont une sous-page est la page affichée.
 *
 * Même sémantique que le `routerLinkActive` non exact posé sur les liens
 * enfants : la route de l'enfant, ou n'importe quelle route sous elle, à une
 * frontière de segment — `…/contracts-archive` n'active pas `…/contracts`.
 * Fonction pure plutôt que `Router.isActive`, déprécié depuis Angular 21.1.
 */
export function contextualGroupsContaining(
  items: ContextualNavigationItem[],
  url: string
): string[] {
  const path = url.split(/[?#]/)[0];

  return items
    .filter(item =>
      item.children?.some(
        child => !!child.route && isWithinRoute(path, child.route)
      )
    )
    .map(item => item.id);
}

/**
 * L'entrée est-elle à allumer en plus de ce que fait `routerLinkActive` sur
 * sa route principale ? Vrai si `active` est posé à la main, ou si la page
 * affichée est sous l'une de ses `alsoActiveOn`.
 */
export function isContextualItemActiveOn(
  item: ContextualNavigationItem,
  url: string
): boolean {
  if (item.active) {
    return true;
  }
  const path = url.split(/[?#]/)[0];
  return (item.alsoActiveOn ?? []).some(route => isWithinRoute(path, route));
}

function isWithinRoute(path: string, route: string): boolean {
  return path === route || path.startsWith(`${route}/`);
}
